import React from "react";
import { Modal } from "react-bootstrap";
import { FiX } from "react-icons/fi";

function PartyInTheParkMay2023({ show, onClose, onOpen }) {
  // const [chatroomShow, setChatroomShow] = useState(false);
  // const handleChatroom = () => setChatroomShow(false);
  return (
    <div>
      <Modal
        size="xl"
        show={show}
        onHide={onClose}
        //  // backdrop="static"
        aria-labelledby="example-modal-sizes-title-lg"
        keyboard={false}
        animation={true}
        centered
      >
        <Modal.Body>
          <div className="Solera__Cont">
            <FiX className="Solera__Close" onClick={onClose} />
          </div>

          <div className="Exoc-Name">Party In The Park May 2023</div>
          {/* <div className="Exco-Tittle">President</div> */}
          <br />

          {/* <div className="NO-Events">BBQ PARTY 2022</div> */}
          <br />
          <div>
            <div className="container-fluid p-0">
              <div className="row g-4">
                <div className="col-lg-4">
                  <div>
                    <img
                      src="/assets/ParkParty2023/1.png"
                      alt=""
                      className="Photogallary2 "
                    />
                  </div>
                </div>
                <div className="col-lg-4">
                  <div>
                    <img
                      src="/assets/ParkParty2023/2.png"
                      alt=""
                      className="Photogallary2 "
                    />
                  </div>
                </div>
                <div className="col-lg-4">
                  <div>
                    <img
                      src="/assets/ParkParty2023/3.png"
                      alt=""
                      className="Photogallary2 "
                    />
                  </div>
                </div>
              </div>
            </div>
            <br />
            <div className="container-fluid p-0">
              <div className="row g-4">
                <div className="col-lg-4">
                  <div>
                    <img
                      src="/assets/ParkParty2023/4.png"
                      alt=""
                      className="Photogallary2 "
                    />
                  </div>
                </div>
                <div className="col-lg-4">
                  <div>
                    <img
                      src="/assets/ParkParty2023/5.png"
                      alt=""
                      className="Photogallary2 "
                    />
                  </div>
                </div>
                <div className="col-lg-4">
                  <div>
                    <img
                      src="/assets/ParkParty2023/6.png"
                      alt=""
                      className="Photogallary2 "
                    />
                  </div>
                </div>
              </div>
            </div>
            <br />
            <div className="container-fluid p-0">
              <div className="row g-4">
                <div className="col-lg-4">
                  <div>
                    <img
                      src="/assets/ParkParty2023/7.png"
                      alt=""
                      className="Photogallary2 "
                    />
                  </div>
                </div>
                <div className="col-lg-4">
                  <div>
                    <img
                      src="/assets/ParkParty2023/8.png"
                      alt=""
                      className="Photogallary2 "
                    />
                  </div>
                </div>
                <div className="col-lg-4">
                  <div>
                    <img
                      src="/assets/ParkParty2023/9.png"
                      alt=""
                      className="Photogallary2 "
                    />
                  </div>
                </div>
              </div>
              <br />
              <div className="container-fluid p-0">
                <div className="row g-4">
                  <div className="col-lg-4">
                    <div>
                      <img
                        src="/assets/ParkParty2023/10.png"
                        alt=""
                        className="Photogallary2 "
                      />
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div>
                      <img
                        src="/assets/ParkParty2023/11.png"
                        alt=""
                        className="Photogallary2 "
                      />
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div>
                      <img
                        src="/assets/ParkParty2023/12.png"
                        alt=""
                        className="Photogallary2 "
                      />
                    </div>
                  </div>
                </div>
                <br />
                <div className="container-fluid p-0">
                  <div className="row g-4">
                    <div className="col-lg-4">
                      <div>
                        <img
                          src="/assets/ParkParty2023/13.png"
                          alt=""
                          className="Photogallary2 "
                        />
                      </div>
                    </div>
                    <div className="col-lg-4">
                      <div>
                        <img
                          src="/assets/ParkParty2023/14.png"
                          alt=""
                          className="Photogallary2 "
                        />
                      </div>
                    </div>
                    <div className="col-lg-4">
                      <div>
                        <img
                          src="/assets/ParkParty2023/15.png"
                          alt=""
                          className="Photogallary2 "
                        />
                      </div>
                    </div>
                  </div>
                  <br />
                  <div className="container-fluid p-0">
                    <div className="row g-4">
                      <div className="col-lg-4">
                        <div>
                          <img
                            src="/assets/ParkParty2023/16.png"
                            alt=""
                            className="Photogallary2 "
                          />
                        </div>
                      </div>
                      <div className="col-lg-4">
                        <div>
                          <img
                            src="/assets/ParkParty2023/17.png"
                            alt=""
                            className="Photogallary2 "
                          />
                        </div>
                      </div>
                      <div className="col-lg-4">
                        <div>
                          <img
                            src="/assets/ParkParty2023/18.png"
                            alt=""
                            className="Photogallary2 "
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default PartyInTheParkMay2023;
